export const styles = {
  select: (theme) => ({
    borderRadius: "8px",
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
    height: 40,
    maxWidth: "100%",
    "& .MuiSelect-select": {
      py: 0,
      height: 40,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      overflow: "hidden",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
    },
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.light,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.light,
      borderWidth: 1,
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
      borderWidth: 2,
    },
    "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
    },
    "&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
    },
  }),
  placeholder: (theme) => ({
    color: theme.palette.text.disabled,
  }),
  valueText: (theme) => ({
    color: theme.palette.text.primary,
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  }),
  selectWithLabel: {
    height: 52,
    "& .MuiSelect-select": {
      height: 52,
      minHeight: 52,
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      gap: 0,
    },
  },
  labelValueStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    minWidth: 0,
    width: "100%",
    lineHeight: 1.2,
  },
  selectLabel: (theme) => ({
    color: theme.palette.text.secondary,
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  }),
  menuItemText: (theme) => ({
    color: theme.palette.text.primary,
  }),
  menuProps: {
    disableScrollLock: true,
    BackdropProps: {
      sx: {
        backgroundColor: "transparent !important",
      },
    },
  },
  loadingIndicator: {
    position: "absolute",
    right: 28,
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    zIndex: 2,
  },
  loadingIndicatorHidden: {
    visibility: "hidden",
    pointerEvents: "none",
  },
  multiRenderRow: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 0.75,
    overflow: "hidden",
    width: "100%",
  },
  groupHeader: (theme) => ({
    fontWeight: 700,
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    lineHeight: "2em",
    bgcolor: theme.palette.background.default,
  }),
  tooltipDiv: {
    display: "block",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  helperText: (theme) => ({
    mx: 0,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight,
    minHeight: "1.66em",
  }),
  sectionsMenuPaper: {
    minWidth: { xs: 280, sm: 340 },
    maxWidth: 420,
    maxHeight: 480,
    borderRadius: 2,
    p: "4px 0",
    overflowX: "hidden",
  },
  sectionHeaderContainer: {
    p: 0,
    lineHeight: "normal",
    backgroundColor: "transparent",
    cursor: "default",
    userSelect: "none",
  },
  sectionDivider: (theme) => ({
    my: "16px!important",
    mx: 2.25,
    borderColor: theme.palette.dividers.main,
  }),
  sectionHeaderBanner: (bg) => ({
    backgroundColor: bg,
    borderRadius: 1,
    py: 1.25,
    px: 2,
    mt: 0.75,
    mx: 1.5,
    mb: 0.75,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  }),
  sectionHeaderTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  sectionHeaderTitle: (color) => ({
    fontWeight: 700,
    color: color,
  }),
  sectionHeaderSubtitle: (color) => ({
    color,
  }),
  sectionItem: (bg) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    py: 1,
    px: 1.5,
    mx: 1.5,
    my: "2px",
    borderRadius: 1,
    "&.Mui-selected": {
      backgroundColor: bg,
      "&:hover": {
        backgroundColor: bg,
      },
    },
  }),
  sectionItemLeft: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    minWidth: 0,
    flex: "1 1 auto",
  },
  sectionItemText: (theme) => ({
    color: theme.palette.common.black,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  selectedCheckIcon: (theme) => ({
    color: theme.palette.primary.blueBright,
    fontSize: 20,
    flexShrink: 0,
    ml: 1,
  }),
  infoIconWrapper: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    p: "2px",
    borderRadius: "50%",
  },
  infoIcon: (color) => (theme) => ({
    fontSize: 16,
    color: theme.palette.primary.blueBright,
  }),
  tooltipPopper: (theme) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 2,
    p: 1.5,
    maxWidth: 340,
  }),
  tooltipScrollBox: {
    maxHeight: 220,
    overflowY: "auto",
    pr: 0.5,
  },
  tooltipArrow: (theme) => ({
    color: theme.palette.common.white,
    "&:before": {
      border: `1px solid ${theme.palette.grey[300]}`,
      backgroundColor: theme.palette.common.white,
      boxSizing: "border-box",
    },
  }),
  tooltipTitle: {
    fontWeight: 700,
    mb: 0.5,
  },
  tooltipBody: (theme) => ({
    color: theme.palette.common.black,
    "& b, & strong": {
      fontWeight: 700,
    },
  }),
}
